import { Link, Outlet, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function SiteLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <div className="flex min-h-screen flex-col bg-background-50 pb-16 md:pb-0">
      <SiteHeader />
      <main className={`flex-1 ${isHome ? "" : "pt-16"}`}>
        <Outlet />
      </main>
      <SiteFooter />
      <MobileSearchBar />
    </div>
  );
}

function MobileSearchBar() {
  const { pathname } = useLocation();
  if (pathname === "/search") return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 p-3 backdrop-blur md:hidden">
      <Link
        to="/search"
        className="flex h-11 w-full items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 text-sm text-foreground-500"
      >
        <i className="ri-search-line text-base"></i>
        <span>搜索电影、电视剧、综艺</span>
      </Link>
    </div>
  );
}